import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { Link } from 'react-router-dom';
import './Head.css';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ThermostatAutoIcon from '@mui/icons-material/ThermostatAuto';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import SatelliteIcon from '@mui/icons-material/Satellite';
import MessageIcon from '@mui/icons-material/Message';

import logo from './../../images/sundarban.gif';


const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

export default function Head() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar style={{ background: 'rgba(0,0,0,0.8)' }} position="fixed" open={open}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{
                            Color: "white",
                            marginRight: 5,
                            ...(open && { display: 'none' }),
                        }}
                    >
                        <MenuIcon></MenuIcon>
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                    <img style={{ width: '100%',height:'70PX' }} src={logo} alt="" />
                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer PaperProps={{
                sx: {
                    backgroundColor: "rgba(0,0,0,0.8)"
                }
            }}  variant="permanent" open={open}>
                <DrawerHeader>
                    <IconButton style={{ color:"white" }} onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <Divider />
                <Link className="bar" to={`/`}>
                    <List>

                        <ListItem>

                            <ListItemIcon><VisibilityIcon className='icon'/>
                            </ListItemIcon><strong className="pra mt-2 mb-1">Home</strong>
                            <ListItemText />
                        </ListItem>

                    </List>

                    <Divider />
                </Link>
                <Link className="bar" to={`/temperature`}>
                    <List>

                        <ListItem>
                            <ListItemIcon> <ThermostatAutoIcon className='icon'/>
                            </ListItemIcon><p className="pra mt-2 mb-1">Temperature</p>
                            <ListItemText />
                        </ListItem>

                    </List>

                    <Divider />
                </Link>
                <Link className="bar" to={`/weather`}>
                    <List>

                        <ListItem>
                            <ListItemIcon> <ThunderstormIcon className='icon'/>
                            </ListItemIcon><p className="pra mt-2 mb-1">Weather</p>
                            <ListItemText />
                        </ListItem>

                    </List>

                    <Divider />
                </Link>
                <Link className="bar" to={`/points`}>
                    <List>

                        <ListItem>
                            <ListItemIcon> <LoyaltyIcon className='icon'/>
                            </ListItemIcon><p className="pra mt-2 mb-1">Points</p>
                            <ListItemText />
                        </ListItem>

                    </List>

                    <Divider />
                </Link>
                <Link className="bar" to={`/rawview`}>
                    <List>

                        <ListItem>
                            <ListItemIcon> <SatelliteIcon className='icon'/>
                            </ListItemIcon><p className="pra mt-2 mb-1">Rawview</p>
                            <ListItemText />
                        </ListItem>

                    </List>

                    <Divider />
                    
                    </Link>
                    <Link className="bar" to={`/message`}>
                    <List>

                        <ListItem>
                            <ListItemIcon> <MessageIcon className='icon'/>
                            </ListItemIcon><p className="pra mt-2 mb-1">Message</p>
                            <ListItemText />
                        </ListItem>

                    </List>

                    <Divider />
                </Link>
            </Drawer>

        </Box>
    );
}
